import { updateField } from "@/redux/feature/creatorApplication/creatorApplicationSlice";
import { useAppDispatch } from "@/redux/hooks/hooks";
import MultiSelect from "./MultiSelect";
import { SelectComponetOption } from "@/types/types";
import { useState } from "react";

type SelectOption = {
  id: string;
  title: string;
};

export const SkillsOptions: SelectOption[] = [
  { id: "Script Writing", title: "Script Writing" },
  { id: "Voiceovers", title: "Voiceovers" },
  { id: "Acting", title: "Acting" },
  { id: "Videography", title: "Videography" },
  { id: "Video-editing", title: "Video-editing" },
  { id: "Modeling", title: "Modeling" },
];

const SelectSkills = ({
  defaultValue,
  setValue,
}: {
  setValue?: (value: any) => void;
  defaultValue?: string;
}) => {
  const dispatch = useAppDispatch();

  // Split the defaultValue string into an array of languages
  const defaultSelectedProps = defaultValue?.split(", ").filter(Boolean);
  // console.log(defaultSelectedProps);
  // Filter the default selected items from the available language options
  const defaultSelectedItems = SkillsOptions.filter((item) =>
    defaultSelectedProps?.includes(item.id)
  );
  const [selectedProps, setSelectedProps] =
    useState<SelectComponetOption[]>(defaultSelectedItems);

  const handleSelectSkills = (options: SelectComponetOption[] | null) => {
    if (options) {
      setSelectedProps(options);
      dispatch(
        updateField({
          field: "skills",
          value: options.map((option) => option.title).join(", "),
        })
      );
      const value = options.map((option) => option.title).join(", ");
      setValue?.(value);
    } else {
      setSelectedProps([]);
      dispatch(updateField({ field: "skills", value: [] }));
      setValue?.("");
    }
  };

  return (
    <div>
      <MultiSelect
        label="Skills that you posses?"
        options={SkillsOptions}
        selectedOptions={selectedProps}
        onSelect={handleSelectSkills}
        placeholder="Select Options..."
        showOtherInputField={true}
      />
    </div>
  );
};

export default SelectSkills;